<template>
  <div>
    <a-button class="top_btn" type="primary"  @click="()=>{  visibleForm = true; titleForm='添加兑换项目' }"> 添加
    </a-button>
    <a-button class="top_btn" type="primary" @click="listOrder()" > 排序</a-button>
    <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="pagination" rowKey="id">
 <span slot="list_order" slot-scope="text, record">
        <a-input   v-model="record.list_order" class="inputs" size="small"/>
      </span>
      <p slot="rule_left" slot-scope="text, record" style="margin-bottom: 0">
        <span v-if="record.exchange_type==1">{{record.rule_left}}积分/{{record.rule_right}}天</span>
        <span v-else-if="record.exchange_type==2">{{record.rule_left}}积分/{{record.rule_right}}万</span>
        <span v-else-if="record.exchange_type==3||record.exchange_type==4||record.exchange_type==5||record.exchange_type==6||record.exchange_type==7">{{record.rule_left}}积分/{{record.rule_right}}条</span>
        <span v-else >{{record.rule_left}}积分/{{record.rule_right}}</span>
            </p>
            <span slot="status" slot-scope="text, record">
         <a-switch   @click="onChange(record)"   :checked="text==1?true:false"/>
            </span>
      <span slot="action" slot-scope="text, record">


                <a @click="(record)=>{visibleForm = true; titleForm='修改兑换项目'; editId=text.id ; }"  >编辑 <a-divider  type="vertical"/></a>
          <a-popconfirm
              title="此操作将永久删除, 是否继续?"
              ok-text="确定"
              cancel-text="取消"
              @confirm="confirm(record)"
              @cancel="()=>{}"
          >
   <a  >删除</a>
  </a-popconfirm>
                    </span>

    </a-table>
    <CustomerPointsTypeAdd :visible="visibleForm" :title="titleForm" :editId="editId"
                       @changVisible=" () => { this.visibleForm = false;this.editId=''; this.getList()}  "/>

  </div>

</template>

<script>
import API from "./api";
import CustomerPointsTypeAdd from "./components/CustomerPointsTypeAdd"
import {changStatus, orderList, removeById} from "../../../utils/utils"

const columns = [
  {
    title: "排序",
    dataIndex: "list_order",
    key: "list_order",
    width: "8%",
    scopedSlots: {customRender: "list_order"}
  },
  {
    title: "兑换方式",
    dataIndex: "exchange_mode_name",
    width: "15%",
    ellipsis: true,
    key: "exchange_mode_name"
  },
  {
    title: "兑换类型",
    dataIndex: "exchange_name",
    ellipsis: true,
    key: "exchange_name"
  },
  {
    title: "兑换规则",
    dataIndex: "rule_left",
    ellipsis: true,
    key: "rule_left",
    scopedSlots: {customRender: "rule_left"}
  },
  {
    title: "状态",
    key: "status",
    width: "10%",
    dataIndex: "status",
    scopedSlots: {customRender: "status"}
  },
  {
    title: "操作",
    key: "action",
    width: "200px",
    scopedSlots: {customRender: "action"}
  }
];
export default {
  name: 'index',
  data() {
    return {

      pagination: {
        pageNo: 1,
        pageSize: 20, // 默认每页显示数量
        onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
        onChange: this.getList.bind(this), //点击页码事件
        total: 0, //总条数
        current: 0,
        size: "small",
        showTotal: total => `共 ${total} 条`,
        showQuickJumper: true
      },
      visibleForm: false,
      titleForm: "",
      loading: true,
      editId: null,
      jurisdictionId: null,
      visibleJurisdiction: false,
      data: [],
      columns,
    }
  },
  created() {
    this.$store.state.adminleftnavnum = "/CustomerPoints/CustomerPointsType"; //设置左侧导航2-2 active
  },
  components: {CustomerPointsTypeAdd},
  methods: {
    listOrder() {
      this.getchangId(this.data)
      orderList(API.service.LIST_ORDER, this.sortLists).then(res => {
        this.getList()
      })
    },
    getchangId(data) {
      this.sortLists=[]
      let sortListOrder = {id: "", list_order: ""}
      for (let i = 0; i < data.length; i++) {
        sortListOrder.id = data[i].id
        sortListOrder.list_order = data[i].list_order
        this.sortLists.push(sortListOrder)
        sortListOrder = {}
        if (data[i].children && data[i].children.length > 0) {
          this.getchangId(data[i].children)
        }
      }
    },
      getList(page) {
      API.service.GET_LIST(page||1).then(res => {
        this.pagination.total = res.data.data.total
        this.pagination.pageSize = res.data.data.per_page
        this.pagination.current = res.data.data.current_page
        this.data = res.data.data.data
        this.loading = false
      })
    },

    onChange(row) {
      let Json = {id: row.id, status: row.status == 0 ? 1 : 0}
      changStatus(API.service.CHANG_STATUS, [Json]).then(res => {
        if (res == true) {
          this.getList()
        }
      })

    },
    confirm(row) {
      removeById(API.service.DELE, [row.id]).then(res => {
        if (res == true) {
          this.getList()
        }
      })
    },
  },
  mounted() {
    this.getList()
  }

}
</script>
